import React, { useState, useEffect } from 'react';
import SociedadEditor from './SociedadEditor';
import { connect } from 'react-redux';

import {
  setPending,
  deleted,
  setDeletedPending,
  getAllDeleted,
  restore,
  getAll,
} from '../redux/actions/sociedadActions';

import { callStatus } from '../utils/constants';
import { Button, Space, Layout, Modal, Tag } from 'antd';
import { withRouter } from 'react-router-dom';

import {
  DeleteFilled,
  SelectOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
  EditFilled,
} from '@ant-design/icons';
import styled from 'styled-components';
import RestorePopup from './RestorePopup';
import MetaTable from './base/MetaTable';
const { confirm } = Modal;

const { Content, Header, Footer } = Layout;

const SelectedContainer = styled.div`
  flex: 1;
`;

const ActionsContainer = styled.div``;

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 10px;
`;
const SociedadList = ({ stateData, dispatch }) => {
  const [showRestore, setShowRestore] = useState(false);

  const [showEdit, setShowEdit] = useState(false);
  const [rowEdit, setRowEdit] = useState(null);

  const [dataSource, setDataSource] = useState([]);

  useEffect(() => {
    getAll(dispatch);
    dispatch(setPending());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (stateData.list.status === callStatus.LIST_SUCCESS) {
      setDataSource(stateData.list.data);
    }
  }, [stateData]);

  const handleEdit = (data) => {
    setRowEdit(data);
    setShowEdit(true);
  };

  const handleRestore = () => {
    setShowRestore(true);
    getAllDeleted(dispatch);
  };

  const handleRestoreCancel = () => {
    setShowRestore(false);
    dispatch(setDeletedPending());
  };

  const handleRestoreOk = (data) => {
    dispatch(restore({ data: data }));
    setShowRestore(false);
  };

  const handleDelete = (data) => {
    dispatch(deleted(data.id));
  };

  const handleHideEditor = () => {
    setShowEdit(false);
    setRowEdit(null);
    dispatch(setPending());
  };

  const handleConfirm = (item) => {
    confirm({
      title: '¿Está a punto de eliminar un registro, desea continuar?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Si',
      cancelText: 'No',
      autoFocusButton: 'cancel',
      onOk() {
        handleDelete(item);
      },
      onCancel() {},
    });
  };

  const restoreColumns = [
    {
      ellipsis: true,
      title: 'Nombre',
      dataIndex: 'nombre',
    },
  ];

  const columns = [
    {
      title: '',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <EditFilled onClick={(e) => handleEdit(record)} />
          <DeleteFilled onClick={(e) => handleConfirm(record)} />
        </Space>
      ),
      width: 60,
    },
    {
      width: 200,
      ellipsis: true,
      title: 'Nombre',
      dataIndex: 'nombre',
      sorter: (a, b) => a.nombre?.localeCompare(b.nombre),
      search: true,
    },
    {
      title: 'Aportantes',
      dataIndex: 'inversores',
      render: (inversores) => (
        <>
          {inversores &&
            inversores.map((inv) => (
              <Tag color="blue" key={inv.inversor_id}>
                {inv.inversor_nombre} ({inv.ganancia}%)
              </Tag>
            ))}
        </>
      ),
    },
  ];

  return (
    <Layout style={{ height: '100%' }}>
      <Header></Header>
      <Content>
        <MetaTable
          dataSource={dataSource}
          dataColumns={columns}
          bordered={false}
          selection={false}
          loading={stateData.list.status === callStatus.LIST_IN_PROCESS}
        />
      </Content>
      <Footer>
        <FooterContainer>
          <SelectedContainer></SelectedContainer>
          <ActionsContainer>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              size="small"
              onClick={(e) => handleEdit({})}
            >
              Agregar Sociedad
            </Button>
            <Button
              type="primary"
              icon={<SelectOutlined />}
              size="small"
              style={{ marginLeft: '3px' }}
              onClick={(e) => handleRestore()}
            >
              Recuperar
            </Button>
          </ActionsContainer>
        </FooterContainer>
      </Footer>
      {showEdit ? (
        <SociedadEditor
          id={rowEdit.id}
          onCancel={handleHideEditor}
          visible={true}
        />
      ) : (
        false
      )}
      {showRestore ? (
        <RestorePopup
          columns={restoreColumns}
          data={stateData.deleted.data}
          onCancel={handleRestoreCancel}
          onOk={handleRestoreOk}
          loading={
            stateData.deleted.status === callStatus.LIST_DELETED_IN_PROCESS
          }
        />
      ) : (
        false
      )}
    </Layout>
  );
};

const mapStateToProps = (state) => {
  const { sociedad } = state;
  const stateData = sociedad;
  return {
    stateData,
  };
};
export default connect(mapStateToProps)(withRouter(SociedadList));
